import { sendRequest, sendRequestJson } from "@/utils";
import { apiRequest } from "@/utils/apiRequest";
import { apiUrl } from "@/utils/apiUrl";

export class CopilotRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async getRolesCopilot() {
		const url = this.urlBase + "/world/api/copilotrole/list";
		try {
			return await sendRequestJson({ data: null, url, method: "GET" });
		} catch (e) {
			console.log("Ups, algoo ha ido mal comprobando el role del usuario", e);
		}
	}

	async getTakeAway(date) {
		const url = this.urlBase + "/world/account/gettakeaway";
		try {
			const data = { date };
			return await sendRequest({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal en el getTakeAway");
		}
	}

	async setMessagePlayed(notificationId) {
		console.log("la notificacion desde el repo", notificationId);
		const url = this.urlBase + "/world/notification/setplayed";
		try {
			return await sendRequestJson({ data: { notification: notificationId }, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido dando por reproducida la notificación");
		}
	}

	async createKioskoWalkin(data) {
		const url = this.urlBase + "/world/api/kiosk/createwalkin";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal creando el walkin desde kiosko");
		}
	}

	async createWalkin(data) {
		const url = this.urlBase + "/world/reservation/createwalkin";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal creando el walkin desde kiosko");
		}
	}

	async registerKioskScanQr(data) {
		const url = this.urlBase + "/world/api/kiosk/register";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal resgistrando la entrada desde el quiosco");
		}
	}

	async registerDoorLog(data) {
		const url = this.urlBase + "/world/doorlog/register";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal resgistrando la entrada");
		}
	}

	async acknowledgeNotification(notificationId) {
		const url = this.urlBase + `/world/api/notification/${notificationId}/ack/`;
		try {
			return await sendRequestJson({ data: { id: notificationId }, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido validando la notificacion");
		}
	}

	async getTables() {
		const url = this.urlBase + "/world/api/tables";
		try {
			return await sendRequestJson({ data: null, url, method: "GET" });
		} catch (e) {
			console.log("Ups, algo ha ido mal en el getTables");
		}
	}

	async updateTable(data) {
		const url = this.urlBase + "/world/api/reservation/updatetable";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal modificando la mesa");
		}
	}

	async updateAvailabilityProduct(data) {
		const url = this.urlBase + "/world/api/product/menu/update-availability-product";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal actualizando el producto.");
		}
	}

	async updateTopChoiceProduct(data) {
		const url = this.urlBase + "/world/api/product/menu/update-top-choice-product";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal actualizando el producto.");
		}
	}

	async updateProductorderDishClass(data) {
		const url = this.urlBase + "/world/api/productorder/update-dish-class";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal actualizando el producto.");
		}
	}

	async markProductOrderAsRejected(data) {
		const url = this.urlBase + "/world/api/productorder/mark-as-rejected";

		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("No se ha podido quitar el producto");
		}
	}

	async markProductOrderAsCancelled(data) {
		const url = this.urlBase + "/world/api/productorder/mark-as-cancelled";

		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("No se ha podido quitar el producto");
		}
	}

	async markProductOrderAsLoss(data) {
		const url = this.urlBase + "/world/api/productorder/mark-as-loss";

		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("No se ha podido quitar el producto");
		}
	}

	async completeMenu(data) {
		const url = this.urlBase + "/world/api/productorder/complete-menu";

		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("No se ha podido completar el menu");
			return { result: -1, message: "No se ha podido completar el menu" };
		}
	}

	async updateProductOrderPrice({ productOrderId, newPrice }) {
		const url = apiUrl(`/world/api/product-orders/${productOrderId}/price`);
		const data = {
			unitaryPrice: parseFloat(newPrice),
		};

		try {
			const response = await apiRequest({
				data,
				body: data,
				url,
				method: "PATCH",
				// contentType: 'application/merge-patch+json' // apiRequest handles this automatically for PATCH if body is present, but let's be safe if needed or trust apiRequest logic
				// apiRequest logic: uses 'application/merge-patch+json' for PATCH.
			});

			if (response.ok) {
				return { result: 0, id: productOrderId }; // Mimic expected success response format
			} else {
				return { result: -1, message: "Error updating product order price" };
			}
		} catch (e) {
			console.log("Error updating product order price", e);
			return { result: -1, message: "Error updating product order price" };
		}
	}

	async getStaffList() {
		const url = this.urlBase + "/world/api/staff";
		try {
			return await sendRequestJson({ data: null, url, method: "GET" });
		} catch (e) {
			console.log("Error obteniendo el staff", e);
			return { error: e };
		}
	}

	async loginStaffByPin(data) {
		const url = this.urlBase + "/world/api/staff/staff-by-pin";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Error en login por pin", e);
			throw e;
		}
	}

	async getServiceRanges(venueId) {
		const url = this.urlBase + `/world/api/venue/${venueId}/ranges`;
		try {
			return await sendRequestJson({ data: null, url, method: "GET" });
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo los rangos de servicio", e);
		}
	}

	async getStaffIncentiveGoalsProgress(staffId) {
		const url = this.urlBase + `/world/api/staff/${staffId}/incentive-goals-progress`;
		try {
			return await sendRequestJson({ data: null, url, method: "GET" });
		} catch (e) {
			console.log("Error obteniendo progreso de objetivos del empleado", e);
			return null;
		}
	}

	/**
	 * Register or update this device on the backend.
	 * Called fire-and-forget on every app load from the router guard.
	 * The backend upserts the CopilotDevice record and returns basic device info.
	 *
	 * @param {object} deviceInfo - Output of deviceManager.getDeviceInfo()
	 * @returns {Promise<object|null>}
	 */
	async registerDevice(deviceInfo) {
		const url = this.urlBase + '/world/api/copilot/device/register';
		try {
			const response = await apiRequest({ url, method: 'POST', body: deviceInfo });
			return response.data;
		} catch (e) {
			console.warn('[CopilotRepository] Device registration failed (non-critical):', e);
			return null;
		}
	}

	/**
	 * Submit a batch of auth events to the backend.
	 * Called fire-and-forget — the caller should NOT await this in the login/logout flow.
	 *
	 * Each event must include:
	 *   - clientEventId {string}  — UUID generated at event time (idempotency key)
	 *   - eventType     {string}  — 'staff_login' | 'staff_logout' | 'pin_failure' | ...
	 *   - clientTimestamp {string} — ISO 8601
	 *   - deviceId      {string}  — from deviceManager.getOrCreateToken()
	 *
	 * For staff_login events also include:
	 *   - staffId       {string|null} — staff UUID from local list
	 *   - pin           {string}      — PIN entered (used for server-side validation, not stored)
	 *   - loginType     {string}      — 'pin' | 'anonymous'
	 *
	 * For pin_failure events also include:
	 *   - metadata      {object}      — { attemptedPin: '1234' }
	 *
	 * @param {Array<object>} events
	 * @returns {Promise<object|null>}
	 */
	async submitAuthEvents(events) {
		const url = this.urlBase + '/world/api/copilot-auth-events/batch';
		try {
			const response = await apiRequest({ url, method: 'POST', body: { events } });
			return response.data;
		} catch (e) {
			console.warn('[CopilotRepository] Auth event submission failed (non-critical):', e);
			return null;
		}
	}
}

export const copilotRepository = new CopilotRepository();
